import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/catalogue", label: "Catalogue" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { itemCount } = useCart();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <nav
      className="fixed top-0 inset-x-0 z-40 bg-[#FAF7F0]/85 backdrop-blur-xl border-b border-black/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <span className="text-[#B8860B] font-display text-2xl tracking-tight">✟ Refuge de la Foi</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.25em] transition-colors ${
                  isActive ? "text-[#B8860B]" : "text-[#1A1A1A]/75 hover:text-[#B8860B]"
                }`
              }
              end
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            data-testid="cart-icon-btn"
            onClick={() => navigate("/panier")}
            className="relative p-2 text-[#1A1A1A] hover:text-[#B8860B] transition-colors"
            aria-label="Panier"
          >
            <ShoppingBag size={22} strokeWidth={1.25} />
            {itemCount > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-1 -right-1 bg-[#B8860B] text-[#0A0A0A] text-[10px] font-semibold min-w-[18px] h-[18px] flex items-center justify-center px-1"
              >
                {itemCount}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2 text-[#1A1A1A]"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-[#FAF7F0]/95">
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.2em] py-2 ${
                    isActive ? "text-[#B8860B]" : "text-[#1A1A1A]/75"
                  }`
                }
                end
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
